<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
				<div style="width: 450px" class="yl-flex flex_between">
					<Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
						<i-button slot="append" icon="ios-search" @click="search"></i-button>
					</Input>
					<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
					<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
				</div>
			</div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                                type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>
                </RadioGroup>
            </div>
            <div class="multiple">
                <div class="child-div">所属部门</div>
                <Select v-model="department" style="width:200px">
                    <Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
                <div class="child-div" style="margin-left: 20px;">回款状态</div>
                <Select v-model="status" style="width:200px">
                    <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="name">
                        <div style="display: flex; align-items: center;">
                            <div v-if="row.type == 1 "
                                 style="text-align: center;width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">
                                个
                            </div>
                            <div v-if="row.type == 2 "
                                 style="text-align: center;width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">
                                企
                            </div>
                            <div style="display: flex;flex-direction: column; align-items: center;">
                                <span>{{row.name}}</span>
                                <span>{{row.phone}}</span>
                            </div>
                        </div>
                    </template>
                    <template slot-scope="{ row,index }" slot="contract">
                        <div class="yellow_btn" style="cursor: pointer;" :data-index="index" @click="checkContract">查看</div>
                    </template>
                    <template slot-scope="{ row }" slot="operation">
                        <!--div v-if="row.status == -1" style="display: flex; justify-content: space-between;">
                            <div style="color: #0092FF;cursor: pointer;" :data-id="row.id"  @click="pass">审核通过</div>
                            <div style="color: red;cursor: pointer;" :data-id="row.id"  @click="refuse">审核拒绝</div>
                        </div>
                        <div v-else style="color: #999999;">{{row.status_name}}</div-->
						<div
							style="display: flex; flex-direction: column; align-items: center;justify-content: space-around; height: 100px;">
							<span style="color: #2A8BF6; cursor: pointer;":data-contract_id="row.contract_id" :data-loan_id="row.id" @click.stop="loanManage">查看</span>
							<span style="color: #2A8BF6; cursor: pointer;":data-contract_id="row.contract_id" :data-loan_id="row.id" v-if="row.status == 1" @click.stop="pass">审核通过</span>
							<span style="color: #555500; cursor: pointer;":data-contract_id="row.contract_id" :data-loan_id="row.id" v-if="row.status == 1" @click.stop="refuse">审核拒绝</span>
							<span style="color: #555500; cursor: pointer;":data-contract_id="row.contract_id" :data-loan_id="row.id"
								:data-client_id="row.id" @click.stop="delLoan">作废</span>
						</div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small"
                      show-elevator/>
            </div>
            <Modal v-model="loanDetailModal" width="900">
                <LoanDetail ref="loanDetail" :loanId="loanId" :contractId="contractId"></LoanDetail>
            </Modal>
            <Modal v-model="checkContractModal">
                <Upload ref="upload" :onlyRead="true"></Upload>
            </Modal>

        </div>
    </Card>
</template>
<script>
	import {
		getRepaymentList,passRepayment,refuseRepayment
	} from '@/api/finance'
	import {
		delLoan
	} from '@/api/client'
	import {mapGetters} from "vuex";
	import {getDepartmentList} from "../../api/user";
    import Upload from '../tool/Upload.vue';
	import LoanDetail from '../task/LoanDetail.vue'

	export default {
        name: "ReturnedAdmin",
        components: {Upload,LoanDetail},

        data() {
            return {
                checkContractModal: false,
				loanDetailModal:false,
                count: 0,
                page: 1,
                name: '',
				loanId:'',
				contractId:'',
                timePeriod: '0',
                timePeriodDate: [],
                department: '0',
                departmentList: [{
                    value: '0',
                    label: '全部'
                }],
                status: '0',
                status_list: [
                    {
                        value: -1,
                        label: '申请中'
                    },
					{
						value: 1,
						label: '已核实'
					},
					{
						value: -2,
						label: '已拒绝'
					}
                ],
                datas: [],
                columns: [
                    {
                        "title": "客户信息",
                        "key": "name",
                        width: '130',
						align:"center"
                    },
					{
					    "title": "手机号码",
					    "key": "phone",
					    width: '130',
						align:"center"
					},
                    {
                        "title": "媒体代码",
                        "key": "media_name",
						align:"center"
                    },
                    {
                        "title": "所属部门",
                        "key": "department",
						align:"center"
                    },
                    {
                        "title": "所属员工",
                        "key": "follow_name",
						align:"center"
                    },
                    {
                        "title": "回款日期",
                        "key": "repay_at",
						align:"center"
                    },
                    {
                        "title": "创收金额",
                        "key": "repay_money",
						align:"center"
                    },
                    {
                        "title": "渠道费用",
                        "key": "channel_fee",
						align:"center"
                    },
                    {
                        "title": "签约费率",
                        "key": "year_rate",
						align:"center"
                    },

                    {
                        "title": "合同",
                        "slot": "contract",
						align:"center"
                    },
                    {
                        "title": "进件状态",
                        "key": "status_name",
						align:"center"
                    },
					{
					    "title": "财务审核",
					    "key": "check_status",
						align:"center"
					},
                    {
                        "title": "审核操作",
                        "slot": "operation",
                        width: "150",
						align:"center"
                    }
                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
			this.loadData();
			this.getList();
		},
        methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.department = 0;
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.status = '';
			},
			async loadData() {
				let that = this;
				that.initSearch();
				var data = {token: this.token};
				var res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			loanManage(e) {
				let that = this;
				that.loanId = e.currentTarget.dataset.loan_id;
				that.loanDetailModal = true;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.menu = 'refund_admin';
				data.token = this.token;
				data.page = this.page;
				let res = await getRepaymentList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			async delLoan(e) {
				let that = this;
				let loan_id = e.currentTarget.dataset.loan_id;
				this.$Modal.confirm({
					title: '确认要作废该进件吗？',
					onOk: async () => {
						let res = await delLoan(that, {
							token: that.token,
							loan_id: loan_id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			search() {
				this.page = 1;
				this.getList();
			},
            pass(e) {
                let that = this;
                let id = e.currentTarget.dataset.loan_id;
                this.$Modal.confirm({
                    title: '确认通过吗？',
                    onOk: async () => {
                        let res = await passRepayment(that, {token: that.token, id: id});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.getList();
                        }
                    }
                })
            },
            refuse(e) {
                let that = this;
                let id = e.currentTarget.dataset.loan_id;
                this.$Modal.confirm({
                    title: '确认拒绝吗？',
                    onOk: async () => {
                        let res = await refuseRepayment(that, {token: that.token, id: id});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.getList();
                        }
                    }
                })
            },
            checkContract(e) {
                let that = this;
                let index = e.currentTarget.dataset.index;
                let row = this.datas[index];
                that.$refs['upload'].uploadList = row.imgList;
                that.checkContractModal = true;
            },
        },
    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
